import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Paper,
  TextField,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Skeleton,
} from "@mui/material";
import styles from "./ViewFeedbackDetails.module.css";
import { useTranslation } from "react-i18next";
import CloseFeedbackDetailsWithStar from "../../basic-component/form-component/feedback-form/CloseFeedbackDetailsWithStar";
import useModal from "../../../hooks/useModal";
import useAddModal from "../../../hooks/useAddModal";
import FeedBacksatisfactionModal from "../../basic-component/Modal/FeedBacksatisfactionModal";
import { IconButton } from "@mui/material";
import { Close as CloseIcon, Description } from "@mui/icons-material";
import Snackbar from "@mui/material/Snackbar";
import Table from "react-bootstrap/Table";
import {
  addSatisfactionURL,
  apiHostUrl,
  getFeedbackDetailsURL,
  getSatisfactionListURL,
} from "../../../../constants/constants";
import axios from "axios";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Badge from "react-bootstrap/Badge";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { CardBody, CardFooter, CardHeader } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Spinner from "react-bootstrap/Spinner";
import { useSelector } from "react-redux";
import useAxiosFetchData from "../../../hooks/useAxiosFetchData";
import API_Routes from "../../../../constants/api-routes";
import PluginSnackbar from "../../basic-component/Snackbar";
import DropdownInputWithLabel from "../../basic-component/DropdownInputWithLabel";
import TextLabel from "../../basic-component/TextLabel";
import {
  postActionDataRefresh,
  selectDeptId,
} from "../../basic-component/CommonUtils";
import { useDispatch } from "react-redux";
import { setReloadFeedbackDetails } from "../../../system/redux/reducers/reloadFeedbackDetails";

const DEFAULT_STAR_RATING = 5;

const CustomerSatisfaction = ({
  onModalCloseHandler,
  isStarEnabled,
  fetchAdditionalData,
  setSnackbarSwitch,
  setSnackbarMessage,
  lastOpen,
  ...props
}) => {
  // Destructure the 'data' prop
  console.log("It is ", fetchAdditionalData, " that this operation is from Dashboard");
  debugger;
  const { data } = props;

  console.log("data", data);
  // debugger;
  const { i18n, t } = useTranslation();
  const [satisfactionTypeList, setSatisfactionTypeList] = useState(
    fetchAdditionalData === true
      ? []
      : data.feedbackSatisfactionDetails.map(
        (item) => item.feedbackSatisfaction
      )
  );
  const [notSatisfactionReasonList, setNotSatisfactionReasonList] = useState(
    fetchAdditionalData === true
      ? []
      : data.feedbackDeSatisfactionDetails.map(
        (item) => item.feedbackDeSatisfaction
      )
  );
  debugger;
  const { isShowing, toggle } = useModal(false);
  const dispatch = useDispatch();
  const { isOpen, val, toggleModal } = useAddModal();
  const [showRating, setShowRating] = useState(true);
  const [showStarRating, setStarRating] = useState(
    fetchAdditionalData !== undefined ? null : data.starEnabled
  );
  // const { isOpen, val, toggleModal } = useAddModal();
  const [satisfactionLevel, setSatisfactionLevel] = useState(
    fetchAdditionalData === undefined && data?.starEnabled
      ? DEFAULT_STAR_RATING
      : -1
  );
  const [reason, setReason] = useState("");
  const [desatisfactionReasonList, setDesatisfactionReasonList] = useState([]);
  const [notSatisfiedReason, setNotSatisfiedReason] = useState(-1);
  // const [lastopen, setLastOpen] = useState(false);
  // const [snackbarMessage, setSnackbarMessage] = useState("");
  const roleId = useSelector((state) => state.role.userCurrRole.id);
  const deptId = useSelector((state) => selectDeptId(state));
  const [feedbackDisSatisfaction, setFeedbackDisSatisfaction] = useState({ "1": "Others" });
  const [closeModal, setCloseModal] = useState(true);
  const { homeLink } = useSelector((state) => state.role);
  const { csrfToken } = useSelector((state) => state.csrf);
  const [loading, setLoading] = useState(false);
  // debugger;
  const [payload, setPayload] = useState({
    department: { id: deptId },
    feedbackCode:
      fetchAdditionalData !== undefined && data
        ? data.feedbackCode
        : data?.feedbackDetails.feedbackCode,
    id:
      fetchAdditionalData !== undefined && data
        ? data.id
        : data?.feedbackDetails.id,
    feedbackSatisfaction: {
      reason: null,
      id: DEFAULT_STAR_RATING,
    },
  });
  // console.log(payload);
  const headers = {
    "Content-Type": "application/json",
    "X-CSRF-TOKEN": csrfToken,
  };

  const [satisfactionPayload, setSatisfactionPayload] = useState(
    fetchAdditionalData !== undefined && data ? data?.department : null
  );

  const { fetchData: fetchSatisfactionData } = useAxiosFetchData({
    url: `${apiHostUrl}${homeLink}${getSatisfactionListURL}`,
    method: "POST",
    body: satisfactionPayload,
    headers: headers,
    onLoad: false,
  });
  const [resolverResponse, setResolverResponse] = useState("");
  const [subPayload, setSubPayload] = useState({
    id:
      fetchAdditionalData !== undefined && data
        ? data.id
        : data?.feedbackDetails.id,
    description: "",
    feedbackDesc: "",
  });
  const { fetchData: getFeedbackData } = useAxiosFetchData({
    url: `${apiHostUrl}${homeLink}${getFeedbackDetailsURL}`,
    method: "POST",
    body: subPayload,
    headers: headers,
    onLoad: false,
  });

  const { value: fetchAgainFlag } = useSelector(
    (state) => state.reloadFeedbackDetails
  );
  useEffect(() => {
    // debugger;
    if (
      subPayload.id !== null &&
      subPayload.id !== undefined &&
      subPayload.id !== "" &&
      (data.resolverDetails === null ||
        data.resolverDetails === undefined ||
        data.resolverDetails.length === 0)
    ) {
      getFeedbackData().then((response) => {
        if (response?.resolverDetails?.length > 0) {
          setResolverResponse(
            response.resolverDetails[0].responseToLogger || ""
          );
        }
      });
    }
  }, []);

  useEffect(() => {
    if (fetchAdditionalData !== undefined) {
      fetchSatisfactionData().then((response) => {
        if (response.success === true) {
          setStarRating(response.starEnabled);
          if (response.starEnabled) {
            setSatisfactionLevel((prev) =>
              prev === -1 || prev === 0 || prev == null
                ? DEFAULT_STAR_RATING
                : prev
            );
          }
          setSatisfactionTypeList(
            response.feedbackSatisfactionDetails.map(
              (item) => item.feedbackSatisfaction
            )
          );
          setNotSatisfactionReasonList(
            response.feedbackDeSatisfactionDetails.map(
              (item) => item.feedbackDeSatisfaction
            )
          );
          // debugger;
        }
      });
    }
  }, [fetchAdditionalData]);

  const { fetchData: postSatisfactionData } = useAxiosFetchData({
    url: `${apiHostUrl}${homeLink}${addSatisfactionURL}`,
    headers: headers,
    method: "POST",
    onLoad: false,
    body: payload,
  });

  const handleModalShow = () => {
    toggleModal(data);
    console.log(isShowing);
  };
  const handleModalClose = (responseData) => {
    console.log("Feedback response:", responseData);
    setSnackbarSwitch(true);
    setSnackbarMessage(responseData);
  };

  const lasthandleClose = () => {
    setSnackbarSwitch(false);
    window.location.href = apiHostUrl;
  };
  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={lasthandleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );
  let resolverVsCustomerReply = (
    <Card className="overflow-hidden mb-2">
      <Table className="mb-0 border-0">
        <thead className="bg-gray">
          <tr>
            <th>{t("feedbackDetails.responseToLogger.text")}</th>

            {/* <TableCell className={styles.tableHeight}>
              Reopen/Unsatisfied Reason
            </TableCell> */}
          </tr>
        </thead>
        <tbody>
          {(resolverResponse ||
            data?.resolverDetails?.[0]?.responseToLogger) ? (
            <tr>
              <TableCell
                dangerouslySetInnerHTML={{
                  __html:
                    resolverResponse ||
                    data?.resolverDetails?.[0]?.responseToLogger ||
                    "",
                }}
              />
            </tr>
          ) : (
            <TableRow>
              <TableCell colSpan={2} className="border-0">
                <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
              </TableCell>
            </TableRow>
          )}
        </tbody>
      </Table>
    </Card>
  );
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitBtnClicked, setIsSubmitBtnClicked] = useState(false);
  useEffect(() => {
    // debugger;
    if (fetchAgainFlag === true || submitted === true) return;
    console.log("1", payload);
    debugger;
    let tempPayload =
      payload?.feedbackSatisfaction?.reason &&
        payload?.feedbackSatisfaction?.reason.length > 0
        ? JSON.parse(payload?.feedbackSatisfaction?.reason)
        : null;
    debugger;
    if (
      (tempPayload !== null &&
        tempPayload !== undefined &&
        tempPayload.length > 0 &&
        tempPayload[0].deSatisfactionReason.trim().length === 0 &&
        (payload.feedbackSatisfaction.id <= 1 ||
          payload.feedbackSatisfaction.id === "101")) ||
      ((payload.feedbackSatisfaction.id <= 1 ||
        payload.feedbackSatisfaction.id === "101") &&
        tempPayload?.length === 0)
    ) {
      console.log("2");
      setCloseModal(false);
      setSnackbarMessage(t("general.label.reason.unsatisfaction"));
      setSnackbarSwitch(true);
      setIsSubmitBtnClicked(false);
      return;
    }
    let shouldExit = false;
    if (tempPayload !== null && tempPayload !== undefined) {
      console.log("3");
      for (let item of tempPayload) {
        console.log("4");
        if ((item.id === 1 || item.id === "1") && reason.length === 0) {
          setCloseModal(false);
          setSnackbarMessage(t("general.label.reason.unsatisfaction"));
          setSnackbarSwitch(true);
          setIsSubmitBtnClicked(false);
          console.log("4.1");
          shouldExit = true;
          setPayload((prev) => {
            return {
              ...prev,
              feedbackSatisfaction: {
                reason: null,
                id: -1,
              },
            };
          });
          break;
        }
      }
    }

    if (shouldExit) return;
    if (
      payload.feedbackSatisfaction.id !== null &&
      payload.feedbackSatisfaction.id > 0 &&
      payload.feedbackSatisfaction?.reason !== null &&
      JSON.parse(payload.feedbackSatisfaction?.reason)[0]
        ?.deSatisfactionReason !== "" &&
      feedbackDisSatisfaction != null &&
      lastOpen !== true
    ) {
      // debugger;
      console.log("5");

      // if (tempPayload.length === 0) then open snackbar and return
      if (tempPayload.length === 0 && payload.feedbackSatisfaction.id <= 1) {
        setCloseModal(false);
        setSnackbarMessage(t("general.label.reason.unsatisfaction"));
        setSnackbarSwitch(true);
        setIsSubmitBtnClicked(false);
        console.log("6");
        return;
      }
      let shouldExit = false;
      // debugger;
      if (
        payload.feedbackSatisfaction.id === "101" &&
        JSON.parse(
          payload.feedbackSatisfaction?.reason
        )[0]?.deSatisfactionReason.trim() === "" &&
        notSatisfiedReason === "1"
      ) {
        console.log(
          JSON.parse(
            payload.feedbackSatisfaction?.reason
          )[0]?.deSatisfactionReason.trim(),
          notSatisfiedReason
        );
        shouldExit = true;
      }
      for (let item of tempPayload) {
        console.log("7");
        debugger;
        if ((item.id === 1 || item.id === "1") && reason.length === 0) {
          setCloseModal(false);
          setSnackbarMessage(t("general.label.reason.unsatisfaction"));
          setSnackbarSwitch(true);
          setIsSubmitBtnClicked(false);
          shouldExit = true;
          setPayload((prev) => {
            return {
              ...prev,
              feedbackSatisfaction: {
                reason: null,
                id: -1,
              },
            };
          });
          break;
        }
      }
      debugger;
      if (shouldExit || fetchAgainFlag) return;
      // debugger;
      // console.log("payload", payload);
      console.log("8", payload);
      // return;
      // debugger;
      // ✅ START LOADER ONLY HERE (AFTER ALL VALIDATIONS)
      if((isSubmitBtnClicked && payload.feedbackSatisfaction.id)&& (payload.feedbackSatisfaction.id > 3 || (payload.feedbackSatisfaction.id <=3 && payload.feedbackSatisfaction.reason) )) {
      setLoading(true);
      setSubmitted(true);

      postSatisfactionData().then((response) => {
        setPayload((prev) => {
          return {
            ...prev,
            feedbackSatisfaction: { reason: null, id: null },
          };
        });
        setIsSubmitBtnClicked(false);
        setCloseModal(true);
        console.log("9");
        setSnackbarSwitch(true);

        setSnackbarMessage(t(response.message));
        setShowRating(false);
        setSatisfactionLevel(-1);
        setNotSatisfiedReason(-1);
        setReason("");
        setLoading(false);
        try {
          postActionDataRefresh(1, null);
          props.refreshDashboard();
        } catch (e) {
          console.log(e);
        }

        try {
          onModalCloseHandler();
        } catch (e) {
          console.log(e);
        }
        if (fetchAdditionalData !== true)
          dispatch(setReloadFeedbackDetails({ value: true }));
      });
    }
    setIsSubmitBtnClicked(false);
    }
  }, [
    payload.feedbackSatisfaction.reason,
    payload.feedbackSatisfaction.id,
    postSatisfactionData,
  ]);

  return (
    <>
      {/* {
        <FeedBacksatisfactionModal
          isShowing={isOpen}
          hide={toggleModal}
          val={val}
          onClose={handleModalClose}
        />
      } */}
      {/* <Paper elevation={3} style={{ padding: '20px', margin: '20px', maxWidth: '600px' }}> */}
      {/* <div>
          <Typography variant="h5" gutterBottom>
            Customer Satisfaction
          </Typography> */}
      {resolverVsCustomerReply}

      {/* <div style={{ marginTop: '20px' }}>
            <Button variant="contained" color="primary" onClick={handleSubmit}>
              Submit
            </Button>

          </div> */}

      {/* <Box mt={2} display="flex" justifyContent="space-between"> */}
      {/* <Button variant="contained" onClick={handleSubmit}>
              {t('general.button.submit.label')}
            </Button> */}
      {/* <Button variant="contained" onClick={(e) => handleModalShow()}>
              Rate us
            </Button> */}
      {/* </Box> */}

      {/* <Typography variant="body1" color="primary" id="messageForSatisfaction" gutterBottom></Typography>
          {lastopen && <Snackbar
            open={lastopen}
            autoHideDuration={5000}
            onClose={lasthandleClose}
            message={snackbarMessage}
            action={action}
          />} */}
      {/* </div> */}
      {/* </Paper> */}
      {/* Wrapper container for all row as flex container and having column direction having some space between
       */}

      {showRating === true && showStarRating === false && (
        <>
          <Row className="justify-content-between">
            <Col>
              {/* <Form.Group as={Row} className="justify-content-between">
                <Form.Label column lg="auto" className="fw-medium">
                  Satisfaction Level
                  <span className="text-danger">*</span>
                </Form.Label>
                <Col lg={9}>
                  <Form.Select
                    value={satisfactionLevel}
                    onChange={(e) => {
                      setSatisfactionLevel(e.target.value);
                      setPayload((prev) => {
                        return {
                          ...prev,
                          feedbackSatisfaction: {
                            reason: prev.feedbackSatisfaction.reason,
                            satisfactionLevel: e.target.value,
                          },
                        };
                      });
                      debugger;
                    }}
                    aria-label="Default select example"
                    name="satisfactionLevel"
                    id="satisfactionLevel"
                  >
                    <option value={-1}>Select</option>
                    {satisfactionTypeList.map((item) => (
                      <option value={item.id}>{item.satisfactionLevel}</option>
                    ))}
                  </Form.Select>
                </Col>
              </Form.Group> */}
              <DropdownInputWithLabel
                label={t("general.lable.satisfactionLevel.text")}
                dropdownItems={satisfactionTypeList}
                onDropdownChangeHandler={(event, index) => {
                  setSatisfactionLevel(event.target.value);
                  setPayload((prev) => {
                    console.log(satisfactionTypeList);
                    // debugger;
                    return {
                      ...prev,
                      feedbackSatisfaction: {
                        reason: prev.feedbackSatisfaction.reason,
                        id: event.target.value,
                      },
                    };
                  });
                }}
                disabled={false}
              />
            </Col>
          </Row>
          {satisfactionLevel !== -1 &&
            satisfactionLevel !== "-1" &&
            payload.feedbackSatisfaction.id !== null &&
            payload.feedbackSatisfaction.id !== -1 &&
            payload.feedbackSatisfaction.id !== "-1" &&
            payload.feedbackSatisfaction.id !== "100" && (
              <Row className="justify-content-between">
                <Col>
                  {/* <Form.Group>
                    <Form.Label column lg="auto" className="fw-medium">
                      Not Satisfaction Reason
                      <span className="text-danger">*</span>
                    </Form.Label>
                    <Col lg={6}>
                      <Form.Select
                        value={notSatisfiedReason}
                        onChange={(e) => {
                          setNotSatisfiedReason(e.target.value);
                          debugger;
                        }}
                        aria-label="Default select example"
                        name="notSatisfiedReason"
                        id="notSatisfiedReason"
                      >
                        <option value={-1}>Select</option>
                        {notSatisfactionReasonList.map((item) => (
                          <option value={item.id}>
                            {item.deSatisfactionReason}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                  </Form.Group> */}
                  <DropdownInputWithLabel
                    label={t("general.lable.unsatisfactionReason.text")}
                    dropdownItems={notSatisfactionReasonList}
                    onDropdownChangeHandler={(event, index) => {
                      console.log(
                        notSatisfactionReasonList,
                        satisfactionLevel,
                        payload
                      );
                      // debugger;
                      // setPayload((prev)=>{
                      //   return {
                      //     ...prev,
                      //     feedbackSatisfaction: {
                      //       reason: {
                      //         deSatisfactionReason:
                      //           notSatisfactionReasonList.filter(
                      //             (item) => item.id === event.target.value
                      //           )[0].deSatisfactionReason,
                      //       },
                      //       id: event.target.value,
                      //     },
                      //   };
                      // });
                      // console.log(
                      //   notSatisfactionReasonList.filter(
                      //     (item) => item.id + "" === event.target.value
                      //   )[0].deSatisfactionReason
                      // );
                      debugger;
                      if (
                        notSatisfactionReasonList.length > 1 &&
                        event.target.value !== "1"
                      ) {
                        setReason(
                          notSatisfactionReasonList.filter(
                            (item) => item.id + "" === event.target.value
                          )[0].deSatisfactionReason
                        );
                        setDesatisfactionReasonList((prev) => {
                          if (
                            prev.filter(
                              (item) => item.id === event.target.value
                            ).length > 0
                          ) {
                            return prev.filter(
                              (item) => item.id !== event.target.value
                            );
                          } else {
                            const newEntry = {
                              id: event.target.value,
                              deSatisfactionReason:
                                notSatisfactionReasonList.filter(
                                  (item) => item.id + "" === event.target.value
                                )[0].deSatisfactionReason,
                            };
                            const newArray = prev;
                            newArray.push(newEntry);
                            return newArray;
                          }
                        });
                      }
                      setNotSatisfiedReason(
                        event?.id ? event.id : event.target.value
                      );
                    }}
                    disabled={false}
                  />
                </Col>
              </Row>
            )}
          {satisfactionLevel !== null &&
            satisfactionLevel !== -1 &&
            satisfactionLevel !== "-1" &&
            satisfactionLevel !== "100" &&
            notSatisfiedReason !== "100" &&
            notSatisfiedReason !== "101" &&
            notSatisfiedReason !== "-1" &&
            notSatisfiedReason !== -1 && (
              <Row className="justify-content-between">
                <Col>
                  <Form.Group className="mb-3 justify-content-between">
                    <Form.Label column lg="auto" className="fw-medium">
                      {t("general.lable.otherReason.text")}
                      <span className="text-danger">*</span>
                    </Form.Label>
                    <Col lg={12}>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        name="reason"
                        id="reason"
                        placeholder={t("general.label.enter.reason")}
                        onChange={(e) => {
                          setReason(e.target.value);
                          setDesatisfactionReasonList((prev) => {
                            const newEntry = prev.filter(
                              (item) => item.id !== "1"
                            );
                            newEntry.push({
                              id: "1",
                              deSatisfactionReason: e.target.value,
                            });
                            return newEntry;
                          });
                        }}
                      ></Form.Control>
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            )}
          {payload.feedbackSatisfaction.id === "100" && (
            <Row className="justify-content-between">
              <Col>
                <Form.Group className="mb-3 justify-content-between">
                  <Form.Label column lg="auto" className="fw-medium">
                    {t("general.lable.otherReason.text")}
                    {/* <span className="text-danger">*</span> */}
                  </Form.Label>
                  <Col lg={12}>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="reason"
                      id="reason"
                      placeholder={t("general.label.enter.reason")}
                      onChange={(e) => {
                        setReason(e.target.value);
                        setDesatisfactionReasonList((prev) => {
                          const newEntry = prev.filter(
                            (item) => item.id !== "1"
                          );
                          newEntry.push({
                            id: "1",
                            deSatisfactionReason: e.target.value,
                          });
                          return newEntry;
                        });
                      }}
                    ></Form.Control>
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          )}
          {/* {satisfactionLevel === "100" && (
            <Row className="justify-content-between">
              <Col>
                <Form.Group className="mb-3 justify-content-between">
                  <Form.Label column lg="auto" className="fw-medium">
                    {t("general.lable.unsatisfactionReason.text")}
                    <span className="text-danger">*</span>
                  </Form.Label>
                  <Col lg={12}>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="reason"
                      id="reason"
                      placeholder={t("general.label.enter.reason")}
                      onChange={(e) => {
                        setReason(e.target.value);
                      }}
                    ></Form.Control>
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          )} */}

          {/* {((satisfactionLevel !== -1 && satisfactionLevel !== "-1") ||
            notSatisfiedReason !== -1) && (
            <Row className="justify-content-between w-100 text-white">
              <Col className="d-flex justify-content-end">
                <Button
                  variant="danger"
                  onClick={onModalCloseHandler}
                  className="btn-danger me-2"
                >
                  Close
                </Button>
                <Button
                  variant="primary"
                  onClick={(e) => {
                    setPayload((prev) => {
                      return {
                        ...prev,
                        feedbackSatisfaction: {
                          reason: reason,
                          id: prev.feedbackSatisfaction.satisfactionLevel,
                        },
                      };
                    });
                  }}
                  className="ms-2 btn-primary"
                >
                  Rate us
                </Button>
              </Col>
            </Row>
          )} */}
        </>
      )}
      {showRating === true && showStarRating === true && (
        <>
          <CloseFeedbackDetailsWithStar
            defaultValue={DEFAULT_STAR_RATING}
            dataListforRating={[
              { value: 1, label: "1/5", colorCode: "#FF5454" },
              { value: 2, label: "2/5", colorCode: "#FF5454" }, // Same color as value 1
              { value: 3, label: "3/5", colorCode: "#F6AD35" },
              { value: 4, label: "4/5", colorCode: "#73B58D" },
              { value: 5, label: "5/5", colorCode: "#73B58D" }, // Same color as value 4
            ]}
            onSatisfactionChange={(newValue) => {
              setSatisfactionLevel(newValue);
              debugger;
              setReason("");
              setIsSubmitBtnClicked(false);
              setPayload((prev) => {
                return {
                  ...prev,
                  feedbackSatisfaction: {
                    reason: null,
                    id: newValue,
                  },
                };
              });
            }}
          ></CloseFeedbackDetailsWithStar>
          {showStarRating === true &&
            payload.feedbackSatisfaction.id !== null &&
            payload.feedbackSatisfaction.id !== undefined && (
              <>
                {/*<Col lg="12" className="reason-area">
                   {payload.feedbackSatisfaction.id <= 1 && (
                    <Form.Label className="fw-medium">
                      {t("general.lable.unsatisfactionReason.text")}
                      <span className="text-danger">*</span>
                    </Form.Label>
                  )} 
                  {payload.feedbackSatisfaction.id <= 1 && (
                    <div key={`inline-radio`} className="mb-3 d-flex">
                       <Form.Check
              inline
              name="group1"
              type={"radio"}
              id={`Complain`}
              label={}
              onClick={() => {}}
              checked={}
            /> */}
                      {/* {payload.feedbackSatisfaction.id <= 1 &&
                        notSatisfactionReasonList.map((item) => {
                          console.log(notSatisfactionReasonList);
                          debugger;
                          return (
                            <div className="d-flex me-3">
                              <input
                                className="me-1"
                                type="checkbox"
                                id={
                                  "unsatisfied" + fetchAdditionalData !==
                                    undefined
                                    ? item.id
                                    : item?.id
                                }
                                checked={
                                  feedbackDisSatisfaction[
                                  fetchAdditionalData !== undefined
                                    ? item.id
                                    : item?.id
                                  ] || false
                                }
                                onChange={(e) => {
                                  setFeedbackDisSatisfaction((prevState) => {
                                    // debugger;
                                    if (e.target.checked) {
                                      return {
                                        ...prevState,
                                        [fetchAdditionalData !== undefined
                                          ? item.id
                                          : item?.id]:
                                          fetchAdditionalData !== undefined
                                            ? item?.deSatisfactionReason
                                            : item?.deSatisfactionReason,
                                      };
                                    } else {
                                      return Object.keys(prevState).reduce(
                                        (newState, key) => {
                                          if (
                                            key !==
                                            (fetchAdditionalData !== undefined
                                              ? item.id.toString()
                                              : item?.id.toString())
                                          ) {
                                            newState[key] = prevState[key];
                                          }
                                          return newState;
                                        },
                                        {}
                                      );
                                    }
                                  });
                                }}
                              />
                              <label
                                htmlFor={
                                  "unsatisfied" +
                                  (fetchAdditionalData !== undefined
                                    ? item?.id
                                    : item?.id)
                                }
                              >
                                {fetchAdditionalData !== undefined
                                  ? item?.deSatisfactionReason
                                  : item?.deSatisfactionReason}
                              </label>
                            </div>
                          );
                        })} */}
                      {/* <Form.Check
              inline
              name="group1"
              type={"radio"}
              label={feedbackTypeList[1].desc}
              id={`General Query`}
              onClick={() => onclickFeedbackTypeHandler(feedbackTypeList[1].id)}
              checked={!selectedType}
            /> 
                    </div>
                  )}
                </Col>*/}
                {(payload.feedbackSatisfaction.id !== null &&
                    payload.feedbackSatisfaction.id !== undefined)  && (
                    <Row>
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlTextarea1"
                        >
                          <TextLabel
                            title={t("general.lable.otherReason.text")}
                            isMandatory={payload.feedbackSatisfaction.id <= 1}
                          ></TextLabel>
                          <Form.Control
                            required
                            value={reason}
                            onChange={(e) => {
                              debugger;
                              setReason((prev) => e.target.value);
                              setDesatisfactionReasonList((prev) => {
                                const newEntry = prev.filter(
                                  (item) => item.id !== "1"
                                );
                                newEntry.push({
                                  id: "1",
                                  deSatisfactionReason: e.target.value,
                                });
                                return newEntry;
                              });
                            }}
                            as="textarea"
                            rows={3}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  )}
              </>
            )}
        </>
      )}
      {((satisfactionLevel !== -1 && satisfactionLevel !== "-1") ||
        notSatisfiedReason !== -1 ||
        (showStarRating === true &&
          showRating === true &&
          (satisfactionLevel !== -1 || satisfactionLevel !== "-1"))) && (
          <Row>
            <Col className="text-end">
              <Button
                variant="outline-dark"
                onClick={onModalCloseHandler}
                className="btn-outline-dark"
              >
                {t("general.button.cancel.label")}
              </Button>
              <Button
                variant="primary"
                onClick={(e) => {
                  // Use the default 5-star value when the user has not clicked a star.
                  const selectedStarRating =
                    satisfactionLevel > 0
                      ? satisfactionLevel
                      : payload?.feedbackSatisfaction?.id;
                  if (
                    showStarRating === true &&
                    (selectedStarRating === 0 ||
                      selectedStarRating === -1 ||
                      selectedStarRating === null ||
                      selectedStarRating === undefined)
                  ) {
                    setSnackbarSwitch(true);
                    setSnackbarMessage(t("Please select a valid rating"));
                    return;
                  }
                  //setLoading(true);
                  setIsSubmitBtnClicked(true);
                  setPayload((prev) => {
                    // console.log({
                    //   reason:
                    //     showStarRating === true
                    //       ? JSON.stringify(
                    //           Object.keys(feedbackDisSatisfaction).map((id) => ({
                    //             id: Number(id),
                    //             deSatisfactionReason:
                    //               id === 1 || id === "1"
                    //                 ? reason
                    //                 : String(feedbackDisSatisfaction[id]),
                    //           }))
                    //         )
                    //       : JSON.stringify(desatisfactionReasonList),
                    //   id: prev.feedbackSatisfaction.id,
                    // });

                    // debugger;
                    // return {};
                    return {
                      ...prev,
                      feedbackSatisfaction: {
                        reason:
                          showStarRating === true
                            ? payload.feedbackSatisfaction.id <= 1
                              ? JSON.stringify(
                                Object.keys(feedbackDisSatisfaction).map(
                                  (id) => ({
                                    id: Number(id),
                                    deSatisfactionReason:
                                      id === 1 || id === "1"
                                        ? reason
                                        : String(feedbackDisSatisfaction[id]),
                                  })
                                )
                              )
                              : JSON.stringify(desatisfactionReasonList)
                            : JSON.stringify(desatisfactionReasonList),
                        id: prev.feedbackSatisfaction.id,
                      },
                    };
                  });
                  console.log(payload);
                  debugger;
                }}
                disabled={loading}
                className="ms-2 btn-primary"
              >
                {loading ? (
                  <>
                    {t('general.button.submit.label')}
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                  </>
                ) : (
                  t('general.button.submit.label')
                )}
              </Button>
            </Col>
          </Row>
        )}
      {/* <PluginSnackbar
        message={snackbarMessage}
        onClose={() => {
          setLastOpen(false);
          if (closeModal) onModalCloseHandler();
        }}
        open={lastopen}
      ></PluginSnackbar> */}
    </>
  );
};

export default CustomerSatisfaction;
